// src/components/langButton.js
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TranslateIcon from '@mui/icons-material/Translate';

const languages = [
  { code: 'en', label: '🇬🇧 English' },
  { code: 'it', label: '🇮🇹 Italiano' },
  { code: 'sq', label: '🇦🇱 Shqip' },
];

const LanguageButton = () => {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const saved = localStorage.getItem('appLang');
    if (saved && saved !== current) {
      i18n.changeLanguage(saved);
      document.documentElement.lang = saved;
    } else {
      document.documentElement.lang = current || 'it';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = async (code) => {
    await i18n.changeLanguage(code);
    localStorage.setItem('appLang', code);
    document.documentElement.lang = code;
    handleClose();
  };

  return (
    <>
      <Tooltip title={t("common.changeLanguage")}>
        <IconButton
          onClick={handleOpen}
          aria-label={t("common.changeLanguage")}
          color="primary"
          sx={{ paddingLeft: "12px", paddingRight: "12px" }}
        >
          <TranslateIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {languages.map(({ code, label }) => (
          <MenuItem
            key={code}
            onClick={() => handleSelect(code)}
            selected={code === current}
            sx={{ fontWeight: code === current ? 'bold' : 'normal' }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageButton;
